module.exports = __webpack_public_path__ + "media/images/emblem-favorite-45e1befc5a840c3c086660304a95d65f.png";